import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SalaryPromotion from './SalaryPromotion';
import { updateValetListData, getValetListData } from "services/redux/Valet/Supervisor/action";

const mapStateToProps = (state) => ({
    updateValetListData: state.CreateSupervisor.updateValetListData,
    valetListData: state.CreateSupervisor.valetListData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        updateValetListData,
        getValetListData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SalaryPromotion);
